// todo add mapping for statuses and get all colors from Nik
import type { FC } from 'react'
import React from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import Typography from '../Typography'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: theme.spacing(1.5),
      height: theme.spacing(3),
      overflow: 'hidden',
      border: '1PX solid #EBEBEB',
      backgroundColor: theme.colors.white,
      padding: theme.spacing(0, 1.375),
      '& p': {
        color: theme.colors.grey800,
        fontSize: '11px',
        fontWeight: 500,
        letterSpacing: '-0.2px',
        lineHeight: '14pX',
      },
    },
    circle: {},
    dot: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      marginRight: 5,
      backgroundColor: theme.colors.grey500,
    },
    Publish: {
      backgroundColor: theme.colors.primary,
    },
    Rejected: {
      backgroundColor: theme.colors.red,
    },
    Quarantined: {
      backgroundColor: theme.colors.red,
    },
    Pending: {
      backgroundColor: theme.colors.gold,
    },
    Draft: {
      backgroundColor: theme.colors.gold,
    },
    Preview: {
      backgroundColor: theme.colors.gold,
    },
  }),
)

interface IProps {
  // todo fix types
  status?:
    | 'Preview'
    | 'Publish'
    | 'Rejected'
    | 'Quarantined'
    | 'Pending'
    | 'Draft'
    | any
  className?: string
}

const StatusLabel: FC<IProps> = ({ status = '', className }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={clsx(classes.dot, status && classes[status])} />
      <Typography>{status}</Typography>
    </div>
  )
}

export default StatusLabel
